import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { GetParticipantsNumber } from './types/getParticipantsNumber.types'
import { getParticipantsNumberInCategory } from '.'

export const getParticipantsNumber: GetParticipantsNumber = (participants) => (
  PARTICIPANTS_CATEGORIES.reduce((participantsNumber, category) => (
    (participants[category].number > 0)
      ? participantsNumber + getParticipantsNumberInCategory(participants, category)
      : participantsNumber
  ), 0)
)
